import type { ProductPromotion } from "@itaas/pep-contracts";
import { isPromotionActive, promoBadgeLabel, promoLabel } from "../../utils/product-promotion";

export function ProductPromotionBadge({
  promotion,
  locale = "fr",
  className = "",
}: {
  promotion: ProductPromotion | undefined | null;
  locale?: "fr" | "en";
  className?: string;
}) {
  if (!isPromotionActive(promotion)) return null;
  const label = promoLabel(promotion!, locale);
  return (
    <span
      className={`badge pep-promo-badge${className ? ` ${className}` : ""}`}
      title={label ?? undefined}
    >
      {promoBadgeLabel(promotion!, locale)}
    </span>
  );
}
